import { Injectable } from '@angular/core';
import { ToolsService } from './tools.service';
import { AuthorizedUser, Credidentials, UserCourse } from './streber-interfaces';
import { QuestionManager } from './question-manager';
import { Subscription } from 'rxjs';
import { Auth, createUserWithEmailAndPassword, getAuth, signInWithEmailAndPassword, UserCredential, User as FirebaseUser, sendEmailVerification, sendPasswordResetEmail } from "@angular/fire/auth";
import { Firestore, collection, getDocs, query, where, doc, getDoc, 
         setDoc, updateDoc, onSnapshot,limit} from '@angular/fire/firestore';
import { signOut, Unsubscribe } from 'firebase/auth';




@Injectable({
  providedIn: 'root'
})
export class UserService {

  public afUser: FirebaseUser;
  public currentAuthorizedUser: AuthorizedUser;
  public currentUserCourse: UserCourse; 
  public lastActiveDay: string = ""; //set by UserCourse-Observable in monitorUserCourse()

  private createUserCourseTries = 0;
  public userCourseIsSet: boolean = false;

  //private userCourseSubscription: Unsubscribe;
  private unsubscribeFromUserCourse: Unsubscribe;

  constructor(public auth: Auth,
              public firestore: Firestore,
              public tools: ToolsService) {
  }

  //done
  public getAuthenticatedUser() {
  //  return this.afAuth.currentUser;
    return this.auth.currentUser;
  }

  public resendVerificationMail() {
    if (this.afUser) {
      sendEmailVerification(this.afUser);
      this.tools.presentAlert("GENERAL.INFO","USER.REGCHECKMAIL");
    }
  }

  public SendPWForgottonMail(eMail: string) {
    return sendPasswordResetEmail(this.auth, eMail);
  }

  //done
  public async register(eMail: string, password:string, preferedLanguage?: string): Promise<boolean> {
    try {
      let uc: UserCredential = await createUserWithEmailAndPassword(this.auth,eMail,password);
      if (uc) {
        console.log(uc);
        this.afUser = uc.user;
        sendEmailVerification(uc.user);
        let authUser: AuthorizedUser = {
          uid: uc.user.uid,
          nickname: eMail, 
          identifier: eMail,
          lastCourse: "", //noch kein Kurs besucht.
          preferedLanguage: preferedLanguage || "en"
        }
        try {
          
          await setDoc(doc(this.firestore, "Users", authUser.uid), authUser);
          //await this.afs.collection("Users").doc(authUser.uid).set(authUser);
          this.currentAuthorizedUser = authUser;
          this.tools.presentAlert("Willkommen","USER.REGCHECKMAIL");
          return true;
        } catch {
          this.tools.presentAlert("GENERAL.ERROR","User-Object not found. Call the admin.");
          return false;
        }
      } else {
        console.log("register failed - no user-object. Call the admin.");
        return false;
      }
    } catch (error) {
      console.log("Error in register: ");
      console.log(error);
      this.tools.presentAlert("GENERAL.ERROR",error);
      return false;
    }
  }

  //done
  public async setLanguage(lang: string) {
    if (this.afUser) {
      let updAuthUser = {
        preferedLanguage: lang
      }
      //await this.afs.collection("Users").doc(this.afUser.uid).update(updAuthUser);
      await updateDoc(doc(this.firestore, "Users", this.afUser.uid), updAuthUser);
      this.currentAuthorizedUser.preferedLanguage = lang;
    }
  }

  //done
  public async changeNickname(nick: string): Promise<boolean> {
    try {
      //let coll: AngularFirestoreCollection = collection(, this.firestore, 'Users', ref => ref
      //  .where("nickname","==",nick) 
      //  .limit(1));
      const q = query(collection(this.firestore, 'Users'), where("nickname","==",nick), limit(1));
      //let snapshot = await coll.get().toPromise();
      const querySnapshot = await getDocs(q);
      //let theDoc = snapshot.docs[0];
      const theDoc = querySnapshot.docs[0];
      if (!theDoc) {
        console.log("Nickname existiert noch nicht.")
        let updAuthUser = {
          nickname: nick
        }
        //await this.afs.collection("Users").doc(this.afUser.uid).update(updAuthUser);
        await updateDoc(doc(this.firestore, "Users", this.afUser.uid), updAuthUser);
        this.currentAuthorizedUser.nickname = nick;
        this.tools.presentAlert("USER.NICKCHANGED","USER.NICKCHANGEEXPL");
        return true;
      } else {
        this.tools.presentAlert("GENERAL.SORRY","USER.NICKNOTAVAILABLE");
        return false;
      }
    } catch (error) {
      console.log("Error in setNickName",error);
      return false;
    }
  }

  //done
  public async login(email: string, password: string): Promise<boolean> {
    try {
      let uid = "";
      let uc: UserCredential = await signInWithEmailAndPassword(this.auth, email, password);
      if (uc) {
        this.afUser = uc.user;
        uid = uc.user.uid;
        console.log("User logged in: ", uc);
        return true;
      } else {
        this.afUser = null;
        this.tools.presentAlert("GENERAL.ERROR","Login ok but no User-Record");
        this.logout();
        return false;
      }
    } catch (error) {
      this.afUser = null
      console.log("Error in login: " + error);
      this.tools.presentAlert("GENERAL.ERROR",error);
      return false;
    }
  } 

  //done
  public async getUserDetails(uid): Promise<AuthorizedUser>  {
    //let doc = await this.afs.collection("Users").doc(uid).get().toPromise();
    const docu = await getDoc(doc(this.firestore, "Users", uid));
    if (docu.exists()) {
      this.currentAuthorizedUser = <AuthorizedUser> docu.data();
      console.log("User Details found");
      return this.currentAuthorizedUser;
    } else {
      console.log("User Details (AutorizedUser) could not be loaded");
      this.tools.presentAlert("GENERAL.ERROR","Userdata not found - that might be a network error.");
      return null;
    }     
  }

  //done
  public async monitorUserCourse(uid: string, cid: string) {
    this.tools.getTimeStampOfWeekStart();
    //check if UserCourse exists already:
    //let doc = await this.afs.collection("UserCourses").doc(uid+"-"+cid).get().toPromise();
    const docu = await getDoc(doc(this.firestore, "UserCourses", uid+"-"+cid));
    if (!docu.exists()) {
      //if not, create new UserCourse-Record
      console.log("try: ceating new Record in UserCourses");
      let userCourse: UserCourse = QuestionManager.newUserCourse(uid,cid);
      try {
        //await this.afs.collection("UserCourses").doc(uid+"-"+cid).set(userCourse)
        await setDoc(doc(this.firestore, "UserCourses", uid+"-"+cid), userCourse);
        console.log("success: new UserCourse created");
      }
      catch(error) {
        console.log("Error in creating userCourse in monitorUserCourse");
        console.log(error);
      };      
    } else {
      //if it exists, check, if fields for new weekHighScore are here:
      this.currentUserCourse = <UserCourse>docu.data();
      console.log(this.currentUserCourse);
      if (!this.currentUserCourse.hasOwnProperty('lastWeekPromotion')) {
        console.log("User depricated - adding fields for Levels");
        var updateObject = {
          dailyTrainingCounter: 0,
          weekStartPoints: 0,
          lastWeekPoints: 0,
          lastWeekRank: 0,
          lastWeekPromotion: "="
        };
        console.log("old record - added fields for levels");
        //await this.afs.collection("UserCourses").doc(uid+"-"+cid).update(updateObject);
        await updateDoc(doc(this.firestore, "UserCourses", uid+"-"+cid), updateObject);
      }
    }

    //done
    //subscribe to existing or just created record
    console.log("Try: subscribing to existing UserCourses");
    //this.userCourseSubscription = this.afs.collection("UserCourses").doc(uid+"-"+cid).snapshotChanges().subscribe(doc =>{
    this.unsubscribeFromUserCourse = onSnapshot(doc(this.firestore, "UserCourses", uid+"-"+cid), docu =>{
      if (docu.exists()) {
        console.log("UserCourses-Subscription just fired.");
        this.userCourseIsSet = true;
        this.currentUserCourse = <UserCourse>docu.data();
        this.userCourseIsSet = false;
        
        if (this.currentUserCourse.lastDay) {
          const lastDay = this.tools.TimeStampToISODate(this.currentUserCourse.lastDay);
          console.log(lastDay);
          if (this.lastActiveDay!="") {
            if (this.lastActiveDay<lastDay)
              console.log("DAYCHANGE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
          }
          this.lastActiveDay = lastDay;
        }
        
      } else {
        console.log("Error: no existing Record in UserCourses found - subscibe not successfull");
      }
    },(error) => {
      console.log("Error in monitorUserCourse", error);
      this.tools.presentAlert("GENERAL.ERROR",error.message);
    });
  
  }

  //done
  public dropUserCourse() {
    if (this.unsubscribeFromUserCourse) {
      console.log("unsubscribing from subscription");
      this.unsubscribeFromUserCourse();
    }
    this.currentUserCourse = null;
  }

  //done
  public logout() {
    if (this.unsubscribeFromUserCourse) {
      this.unsubscribeFromUserCourse();
    }
    this.currentUserCourse = null;
    //this.afAuth.signOut();
    signOut(this.auth);
  }

  //done
  // Function is called to save the changed seetings-values in UserCourse
  saveSettings() {
    if (this.currentUserCourse && !this.userCourseIsSet)
    /*this.afs.collection("UserCourses")
      .doc(this.currentUserCourse.uid+"-"+this.currentUserCourse.cid)
      .update({
        settingShowInHighScore: this.currentUserCourse.settingShowInHighScore || false,
        settingUseTwoStepReviewSubmit: this.currentUserCourse.settingUseTwoStepReviewSubmit || false
      }).then(()=>{
      console.log("Settings saved");
    });*/
    updateDoc(doc(this.firestore, "UserCourses", this.currentUserCourse.uid+"-"+this.currentUserCourse.cid), {
      settingShowInHighScore: this.currentUserCourse.settingShowInHighScore || false,
      settingUseTwoStepReviewSubmit: this.currentUserCourse.settingUseTwoStepReviewSubmit || false
    }).then(()=>{
      console.log("Settings saved");
    }
    );
  }


}
